import LocationPieceRecords from "./LocationPieceRecords";

export default LocationPieceRecords;
